/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { IIndexedNode } from '../../../core/models/IIndexedNode';
import { Node } from '../../../core/models/Node';
import { IVisitor } from '../../../core/visitors/IVisitor';
import { IOas20Visitor } from '../visitors/IOas20Visitor';

/**
 * Constructor.
 * @class
 * @extends Node
 * @author eric.wittmann@gmail.com
 */
export class Oas20SecurityDefinitions extends Node implements IIndexedNode<Oas20SecurityScheme> {
    public items : any;

    public constructor() {
        super();
        if(this.items===undefined) this.items = null;
    }

    /**
     * @see io.apicurio.datamodels.core.models.Node#accept(io.apicurio.datamodels.core.visitors.IVisitor)
     * @param {*} visitor
     */
    public accept(visitor : IVisitor) {
        let viz : IOas20Visitor = <IOas20Visitor><any>visitor;
        viz.visitSecurityDefinitions(this);
    }

    /**
     * Gets a list of all the security scheme names.
     * @return {string[]}
     */
    public getSecuritySchemeNames() : Array<string> {
        let rval : Array<string> = <any>([]);
        if(this.items != null) {
            /* addAll */((l1, l2) => l1.push.apply(l1, l2))(rval, /* keySet */Object.keys(this.items));
        }
        return rval;
    }

    /**
     * Returns a single security scheme by name.
     * @param {string} name
     * @return {Oas20SecurityScheme}
     */
    public getSecurityScheme(name : string) : Oas20SecurityScheme {
        if(this.items != null) {
            return /* get */((m,k) => m[k]===undefined?null:m[k])(this.items, name);
        }
        return null;
    }

    /**
     * Returns an array of all the security schemes.
     * @return {Oas20SecurityScheme[]}
     */
    public getSecuritySchemes() : Array<Oas20SecurityScheme> {
        let rval : Array<Oas20SecurityScheme> = <any>([]);
        if(this.items != null) {
            /* addAll */((l1, l2) => l1.push.apply(l1, l2))(rval, /* values */(obj => Object.keys(obj).map(key => obj[key]))(this.items));
        }
        return rval;
    }

    /**
     * Adds a security scheme child node.
     * @param {string} name
     * @param {Oas20SecurityScheme} scheme
     */
    public addSecurityScheme(name : string, scheme : Oas20SecurityScheme) {
        if(this.items == null) {
            this.items = <any>({});
        }
        /* put */(this.items[name] = scheme);
    }

    /**
     * Removes a single security scheme by name.
     * @param {string} name
     * @return {Oas20SecurityScheme}
     */
    public removeSecurityScheme(name : string) : Oas20SecurityScheme {
        if(this.items != null) {
            return /* remove */(map => { let deleted = this.items[name];delete this.items[name];return deleted;})(this.items);
        }
        return null;
    }

    /**
     * Creates a child security scheme object and adds it to the list.
     * @param {string} name
     * @return {Oas20SecurityScheme}
     */
    public createSecurityScheme(name : string) : Oas20SecurityScheme {
        let rval : Oas20SecurityScheme = new Oas20SecurityScheme(name);
        rval._ownerDocument = this.ownerDocument();
        rval._parent = this;
        return rval;
    }

    /**
     * @see io.apicurio.datamodels.core.models.IIndexedNode#getItem(java.lang.String)
     * @param {string} name
     * @return {Oas20SecurityScheme}
     */
    public getItem(name : string) : Oas20SecurityScheme {
        return this.getSecurityScheme(name);
    }

    /**
     * @see io.apicurio.datamodels.core.models.IIndexedNode#getItems()
     * @return {Oas20SecurityScheme[]}
     */
    public getItems() : Array<Oas20SecurityScheme> {
        return this.getSecuritySchemes();
    }

    /**
     * @see io.apicurio.datamodels.core.models.IIndexedNode#getItemNames()
     * @return {string[]}
     */
    public getItemNames() : Array<string> {
        return this.getItemNames();
    }

    public addItem$java_lang_String$io_apicurio_datamodels_openapi_v2_models_Oas20SecurityScheme(name : string, item : Oas20SecurityScheme) {
        this.addSecurityScheme(name, item);
    }

    /**
     * @see io.apicurio.datamodels.core.models.IIndexedNode#addItem(java.lang.String, io.apicurio.datamodels.core.models.Node)
     * @param {string} name
     * @param {Oas20SecurityScheme} item
     */
    public addItem(name? : any, item? : any) : any {
        if(((typeof name === 'string') || name === null) && ((item != null && item instanceof <any>Oas20SecurityScheme) || item === null)) {
            return <any>this.addItem$java_lang_String$io_apicurio_datamodels_openapi_v2_models_Oas20SecurityScheme(name, item);
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.core.models.IIndexedNode#deleteItem(java.lang.String)
     * @param {string} name
     * @return {Oas20SecurityScheme}
     */
    public deleteItem(name : string) : Oas20SecurityScheme {
        return this.removeSecurityScheme(name);
    }
}
Oas20SecurityDefinitions["__class"] = "io.apicurio.datamodels.openapi.v2.models.Oas20SecurityDefinitions";
Oas20SecurityDefinitions["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable","io.apicurio.datamodels.core.models.IIndexedNode"];





import { Oas20SecurityScheme } from './Oas20SecurityScheme';

